import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {RouteService} from '../../shared/services/route.service';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {EditingService} from '../../shared/services/editing.service';
import {Reservation, ReservationCreate, ReservationUpdate} from '../../shared/models/reservation.model';
import {AuthenticationService} from '../../authentication/authentication.service';
import {Subject} from 'rxjs';
import {UserLogin} from '../../shared/models/user.model';
import {Ticket, TicketCreate} from '../../shared/models/ticket.model';
import {LogCreate} from 'src/app/shared/models/log.model';
import {UserService} from '../../shared/services/user.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {DiscountService} from '../../shared/services/discount.service';
import {Discount} from '../../shared/models/discount.model';
import {IntlTellInputService} from '../../shared/services/intl-tell-input.service';
import {ToolsService} from '../../shared/services/tools.service';
import swal from 'sweetalert2';
import {QrGeneratorService} from '../../shared/services/qr-generator.service';
import {takeUntil} from 'rxjs/operators';
import {Location} from '@angular/common';
import {SendEmailService} from '../../shared/services/send-email.service';
import {Setting} from "../../shared/models/setting.model";
import {Passenger} from "../../shared/models/passenger.model";
import {Observable} from 'rxjs/Rx';
import {FlightCreate, FlightUpdate} from "../../shared/models/flight.model";

@Component({
    selector: 'form-edit-reservation',
    templateUrl: 'form-edit-reservation.html'
})
export class FormEditReservationComponent implements OnInit, OnDestroy {

    @Input() reservation_id: number;
    @Input() reservation: Reservation;
    @ViewChild('f') sendEmailForm: NgForm;
    id: number;
    passengers: Passenger[] = [];
    tickets: Ticket[] = [];
    setting: Setting;
    bookingForm: FormGroup;
    date: string;
    routeGroups: number[] = [];

    isValidTicket = false;
    isEmailTicket = false;

    is_phone_valid: boolean;

    discountOptions: any;
    discountConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['value']
    };
    statusOptions: any = [{'value': ''}, {'value': 'pending'}, {'value': 'confirmed'}, {'value': 'canceled'}];
    statusConfig: any = {
        labelField: 'value',
        valueField: 'value',
        searchField: ['value']
    };

    is_discount: boolean;
    is_discount_expired: boolean;
    discount_type = '';
    discount: Discount;

    agencyOptions: any = [];

    user: UserLogin;

    pnr = '';

    log_txt = '';
    log_txt_divided='';
    error_message = '';

    ipAddress = '';

    is_on_process: boolean;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private routeService: RouteService,
                private dataStorageService: DataStorageService,
                private editingService: EditingService,
                private userService: UserService,
                private discountService: DiscountService,
                private router: Router,
                private qrGeneratorService: QrGeneratorService,
                private toolsService: ToolsService,
                private intlTellInputService: IntlTellInputService,
                private authenticationService: AuthenticationService,
                private _location: Location,
                private sendEmailService: SendEmailService,
                private route: ActivatedRoute) {
        this.discountOptions = [];
        this.is_discount = false;
        this.is_discount_expired = false;
        this.is_phone_valid = false;
        this.is_on_process = false;
    }

    ngOnInit() {

        this.isValidTicket = +this.reservation.is_valid_ticket === 1;

        this.initDiscount();

        this.setPassengerNum();

        this.initBookingForm();

        this.initAgencyOptions();

        this.bookingForm.get('isValidTicket').valueChanges
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                if (value === 1) {
                    this.isValidTicket = true;
                    this.editingService.setIsValidTicket(true);
                    this.editingService.resetInvoice();
                } else {
                    this.isValidTicket = false;
                    this.editingService.setIsValidTicket(false);
                    // this.editingService.setInvoice();
                }
                this.toggleTicketInformation();
            }
        );

        this.intlTellInputService.tellChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.bookingForm.get('phone').setValue(value);
                this.is_phone_valid = true;
            }
        );

        this.intlTellInputService.isTellError
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                // put any value when error because not null
                this.bookingForm.get('phone').setValue('0');
                this.bookingForm.get('phone').markAsTouched();
                this.bookingForm.get('phone').markAsDirty();
                this.is_phone_valid = false;
            }
        );

        this.bookingForm.get('pnr').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                value => {
                    this.editingService.pnrChanged.next(value);
                }
            );

      this.intlTellInputService.isTellError
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          value => {
            //this.editingService.pnrChanged.next(value);
            this.bookingForm.get('ticket_no').setValue(value);
          }
        );

      this.bookingForm.get('discount_id').valueChanges
        .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                value => {
                    if (value !== '') {
                        this.editingService.setDiscountInUseById(value);
                    }
                    this.editingService.setInvoice();
                }
            );
        // if new travel dep date no valid for the discount, empty discount form
        this.editingService.discountInUseSub
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            value => {
                if (!value) {
                    this.bookingForm.get('discount_id').setValue('0');
                }
            }
        );

        this.editingService.log_txt_sub.pipe(takeUntil(this.unsubscribe$)).subscribe(
            log_txt => {
                this.log_txt += log_txt;
            }
        );

        this.editingService.error_message_sub.pipe(takeUntil(this.unsubscribe$)).subscribe(
            error_message => {
                // this.log_txt += error_message;
                this.error_message += error_message;
                alert(error_message);
            }
        );

        this.authenticationService.user.pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            this.user = user;
        });

        this.userService.setIPAddress().pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
                this.ipAddress = res.ip;
            }
        );
      this.route.params
        .subscribe(
          (params: Params) => {
            this.id = +params['id'];
            this.dataStorageService.fetchReservation(this.id)
              .pipe(takeUntil(this.unsubscribe$)).subscribe(
              reservation => {
                this.reservation = reservation;
                this.passengers = this.reservation.passenger;
              }
            );
          }
        );

    }
    // reservation -> ticket, passengers
    onSubmit() {
        if (this.bookingForm.valid) {
            this.submitReservation();
        } else {
            swal(
                'Please check Information'
            );
        }

    }
    // update and email
    onSubmitEmail() {
        this.isEmailTicket = true;
        this.onSubmit();
    }

    initForm() {
      this.sendEmailForm.form.patchValue({
        email: this.reservation.email
      });
    }

    SendEmail(reservation_id: number) {
        if (!reservation_id) {
            alert('Email failed.');
            return;
        }

        this.dataStorageService.fetchReservation(reservation_id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            reservation => {
                this.reservation = reservation;

                const emailTo = (this.bookingForm && this.bookingForm.value.email)
                    ? this.bookingForm.value.email
                    : reservation.email;

                if (!emailTo) {
                    alert('Email failed.');
                    return;
                }

                const emailObj = {
                    type: 1,
                    email_to: emailTo,
                    reservation: this.reservation
                };
                this.sendEmailService.initEmail(emailObj);

                // Log which address the confirmation email was sent to.
                const emailLog = new LogCreate(
                    this.user.id,
                    'Email sent to ' + emailTo + '.<br>',
                    this.ipAddress
                );
                emailLog.reservation_id = reservation_id;
                this.dataStorageService.createLog(emailLog)
                    .pipe(takeUntil(this.unsubscribe$)).subscribe();

                setTimeout(() => {
                    alert('Email sent');
                }, 2000);
            },
            () => {
                alert('Email failed.');
            }
        );
    }
    submitReservation() {

        // set error check
        this.setTimeForCheckError(this.reservation_id);

        if (this.reservation.email === this.bookingForm.value.email
            && this.reservation.phone === this.bookingForm.value.phone
            && this.reservation.comment === this.bookingForm.value.comment
            && this.reservation.is_valid_ticket === this.bookingForm.value.isValidTicket
            && this.reservation.status === this.bookingForm.value.status
            && this.reservation.user_id === this.bookingForm.value.user_id
            && this.reservation.discount_id === this.bookingForm.value.discount_id) {
            // same. just go check passenger, ticket.
            this.editingService.setTicketsEmitter.emit(this.reservation.id);
            this.editingService.setPassengersEmitter.emit(this.reservation.id);
        } else {
            // update
            const newReservation =
                new ReservationUpdate(
                    this.reservation.id, this.bookingForm.value.email, this.bookingForm.value.phone,
                    this.bookingForm.value.comment, this.bookingForm.value.isValidTicket,
                    this.bookingForm.value.status, this.bookingForm.value.user_id, this.bookingForm.value.discount_id);

            this.dataStorageService.updateReservation(newReservation)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                if (responseData['error']) {
                    this.editingService.error_message_sub.next('Updating reservation info Failed. ');
                } else {
                    // log
                    if (this.reservation.email !== this.bookingForm.value.email) {
                        this.log_txt += 'Reservation email changed from '
                            + this.reservation.email
                            + ' to ' + this.bookingForm.value.email + '.<br>';
                    }
                    if (this.reservation.phone !== this.bookingForm.value.phone) {
                        this.log_txt += 'Reservation phone changed from '
                            + this.reservation.phone
                            + ' to ' + this.bookingForm.value.phone + '.<br>';
                    }
                    if (this.reservation.comment !== this.bookingForm.value.comment) {
                        this.log_txt += 'Reservation comment changed from ( '
                            + this.reservation.comment
                            + ' ) to ( ' + this.bookingForm.value.comment + ' ) .<br>';
                    }
/*                    if (this.reservation.is_valid_ticket !== this.bookingForm.value.isValidTicket) {
                        this.log_txt += 'Reservation is_valid_ticket changed from '
                            + this.reservation.is_valid_ticket
                            + ' to ' + this.bookingForm.value.isValidTicket + '.<br>';
                    }*/
                    if (this.reservation.status !== this.bookingForm.value.status) {
                        this.log_txt += 'Reservation status changed from '
                            + this.reservation.status
                            + ' to ' + this.bookingForm.value.status + '.<br>';
/*                        if ( this.bookingForm.value.status === 'confirmed') {
                          this.SendEmail(this.reservation_id);
                        }*/
                    }
                    this.editingService.setTicketsEmitter.emit(newReservation.id);
                    this.editingService.setPassengersEmitter.emit(newReservation.id);
                }
            });
        }

    }

    onDivide() {
        const passengers = this.editingService.getIsDividePassengers();
        if (passengers.length > 0) {
            swal({
                title: 'Are you sure?',
                text: 'Your reservation will be divided. ',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, divide it!'
            }).then((result) => {
                if (result['value']) {
                    this.is_on_process = true;
                    const reservation =
                        new ReservationCreate(this.reservation.user_id, this.reservation.discount_id, this.reservation.email
                            , this.reservation.phone, this.reservation.comment, this.reservation.is_valid_ticket, this.reservation.status);

                    this.dataStorageService.createReservation(reservation)
                        .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                        if (responseData['error']) {
                            this.editingService.error_message_sub
                                .next('Initial Reservation Create from Reservation #' + this.reservation.id + ' failed. ');
                        } else {
                            // save qr
                            this.qrGeneratorService.getQrImg(responseData.id)
                                .pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                                const qrid = response.qrid;
                                this.dataStorageService.updateReservationQr(qrid, responseData.id)
                                    .pipe(takeUntil(this.unsubscribe$)).subscribe(
                                    res => {
                                        if (res['error']) {
                                            alert('Update Qr code error');
                                        } else {
                                            // set error check
                                            this.setTimeForCheckError(responseData.id);

                                            // log
                                            this.log_txt += 'This reservation has been created by dividing Reservation #' + this.reservation.id + '. ';
                                            this.submitIsDividePassengers(responseData.id);
                                            this.submitIsDivideTickets(responseData.id);
                                        }
                                    }
                                );
                            });
                        }
                    });
                }
            });
        } else {
            swal(
                'No One Selected', 'Please Select the passenger to be divided first. '
            );
        }
    }

    submitIsDividePassengers(reservation_id: number) {
        const passengers = this.editingService.getIsDividePassengers();
        let passenger_ids = [];
        for (const passengerEl of passengers) {
            passenger_ids.push(passengerEl.id);
        }
        this.dataStorageService.updatePassengerReservationId(passenger_ids, reservation_id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
            if (responseData['error']) {
                this.editingService.error_message_sub.next('Move Divided Passenger(s) To New Reservation failed. ');
            } else {
                this.log_txt += 'Move Divided Passenger(s) To New Reservation Success. ';
            }
        });
    }

    submitIsDivideTickets(reservation_id: number) {
        const ticket = new TicketCreate(this.reservation.ticket.date, this.reservation.ticket.route.id
            , reservation_id, this.reservation.ticket.status);
        this.dataStorageService.createTicket(ticket)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['error']) {
                    this.editingService.error_message_sub.next('Copying Departure Ticket to Divided Reservation Failed. ');
                } else {
                    this.log_txt += 'Copying Departure Ticket to Divided Reservation Success. ';
                }
            }
        );

        if (this.reservation.ticket_re) {
            const ticket_re = new TicketCreate(this.reservation.ticket_re.date, this.reservation.ticket_re.route.id
                , reservation_id, this.reservation.ticket_re.status);
            this.dataStorageService.createTicket(ticket_re)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                        this.editingService.error_message_sub.next('Copying Returning Ticket to Divided Reservation Failed. ');
                    } else {
                        this.log_txt += 'Copying Returning Ticket to Divided Reservation Success. ';
                    }
                }
            );
        }
    }

    initBookingForm() {

        this.bookingForm = new FormGroup({
            'isValidTicket': new FormControl(+this.reservation.is_valid_ticket, Validators.required),
            'user_id': new FormControl(this.reservation.user_id, Validators.required),
            'status': new FormControl(this.reservation.status, Validators.required),
            'email': new FormControl(this.reservation.email, [Validators.required, Validators.email]),
            'phone': new FormControl(this.reservation.phone, [Validators.required
                , Validators.minLength(10)]),
            'pnr': new FormControl(this.isValidTicket ? this.reservation.passenger[0].flight.pnr : null),
            'discount_id': new FormControl(this.reservation.discount_id),
            'comment': new FormControl(this.reservation.comment)
        });
    }

    asyncInvalidProjectName(control: FormControl): Promise<any> | Observable<any> {
      const promise = new Promise((resolve, reject) => {
        this.dataStorageService.fetchFlightTicketNoCount(control.value)
          .pipe(takeUntil(this.unsubscribe$)).subscribe(
          value => {
            if (value) {
              alert('This ticket number is already in use. ');
              control.patchValue(null);
              resolve({'ticketNoTaken': true});
            } else {
              resolve(null);
            }
          }
        );
      });
      return promise;
    }

    toggleTicketInformation() {
        if (this.isValidTicket) {
            this.bookingForm.addControl('pnr', new FormControl());
        } else {
            this.bookingForm.removeControl('pnr');
        }
    }

    setPassengerNum() {
        for (const passenger of this.reservation.passenger) {
            if (passenger.type === 'Adult') {
                this.editingService.plus_adult_num(1);
            } else if (passenger.type === 'Child') {
                this.editingService.plus_child_num(1);
            } else if (passenger.type === 'Infant') {
                this.editingService.plus_infant_num(1);
            }
        }
    }

    initDiscount() {
        const discounts = this.discountService.getDiscount();
        if (discounts) {
            this.editingService.setDiscount(discounts);
            this.discountOptions = [{'label': 'No Discount', 'value': 0}];
            const today_raw = new Date();
            const today = this.toolsService.formatDate(today_raw);
            for (const discount of discounts) {
                if (discount.start_issue <= today && discount.end_issue >= today) {
                    this.discountOptions.push({'label': discount.code, 'value': discount.id});
                } else {
                    if (this.reservation.discount_id) {
                        if (discount.id === this.reservation.discount_id) {
                            this.discountOptions.push({'label': discount.code + ' (Expired)', 'value': discount.id});
                            this.is_discount_expired = true;
                        }
                    }
                }
            }
            if (this.reservation.discount_id) {
                this.editingService.setDiscountInUseById(this.reservation.discount_id);
            }
        }
        if (this.isValidTicket) {
            this.editingService.setIsValidTicket(true);
        } else {
            this.editingService.setIsValidTicket(false);
        }
    }

    initAgencyOptions() {
        const users = this.userService.getUser();
        users.sort((a, b) => (a.user_name.toUpperCase() < b.user_name.toUpperCase() ? -1 : 1));
        for (const user of users) {
            this.agencyOptions.push({'label': user.user_name, 'value': user.id, 'code': user.user_name});
        }
    }

    ngOnDestroy() {
        this.editingService.reset();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    // check if error
    setTimeForCheckError(reservation_id: number) {
        this.is_on_process = true;
        setTimeout(() => {
            if (this.error_message === '') {
                this.is_on_process = false;
                this.onSuccess(reservation_id);
            } else {
                // this.is_on_fail = true;
            }
        }, 3000);
    }

    onSuccess(reservation_id) {
        // Send email using the id passed in (route-resolved).
        if (this.isEmailTicket === true) {
            this.SendEmail(reservation_id);
        }

        // Compare by numeric value so a string/number mismatch does not
        // falsely flag a normal save as a "divided" reservation.
        const isDivided = +reservation_id !== +this.reservation.id;

        if (isDivided) {
            // Divided reservation flow: log on the original, then navigate + reload.
            const link_new = `<a href="https://admin.ozshuttle.com/#/pages/edit-reservation/${reservation_id}" target="_blank" >Click Here</a>`;
            this.log_txt_divided = `${link_new}: This reservation has been divided into Reservation #${reservation_id}.`;
            const originalLog = new LogCreate(this.user.id, this.log_txt_divided, this.ipAddress);
            originalLog.reservation_id = this.reservation.id;

            if (this.log_txt) {
                const newLog = new LogCreate(this.user.id, this.log_txt, this.ipAddress);
                newLog.reservation_id = reservation_id;
                this.dataStorageService.createLog(newLog).pipe(takeUntil(this.unsubscribe$)).subscribe();
            }

            this.dataStorageService.createLog(originalLog).pipe(takeUntil(this.unsubscribe$))
                .subscribe(() => {
                    this.router.navigate(['/pages/edit-reservation', reservation_id])
                        .then(() => {
                            location.reload();
                        });
                });
            return;
        }

        // Normal update flow.
        if (this.log_txt) {
            // Something changed -> save the change log, THEN reload.
            const newLog = new LogCreate(this.user.id, this.log_txt, this.ipAddress);
            newLog.reservation_id = reservation_id;
            this.dataStorageService.createLog(newLog)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(() => {
                    setTimeout(() => {
                        alert('Reservation Updated.');
                        location.reload();
                    }, 1500);
                });
        } else {
            // Nothing changed -> no log, just reload.
            setTimeout(() => {
                alert('Reservation Updated.');
                location.reload();
            }, 1500);
        }
    }
}
